import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { selectPropertyStatuses } from '../../store/slices/mapSlice';
import { useGetMapInitDataQuery } from '../../store/slices/apiSlice/map-api-slice';
import Loader from '../loader/loader';
import { PropertyStatuses } from '../../utilities/kanbanHelpers';
import Kanban from '../kanban';
import KanbanPropertyCard from '../kanbanPropertyCard';

const PropertyPipelineStatuses = [
    PropertyStatuses.LEAD,
    PropertyStatuses.OPPORTUNITY,
    PropertyStatuses.DETAILED_FEASIBILITY,
    PropertyStatuses.OFFER_ACCEPTED,
];

function PropertyPipelineKanban() {
    const { isLoading: mapInitIsLoading, error: initError } =
    useGetMapInitDataQuery();
    const propertyStatusesDict = useAppSelector(selectPropertyStatuses);

    const renderPropertyCard = (item, index, handleNotFeasible) => {
        return (
            <KanbanPropertyCard
                key={item.id}
                item={item}
                index={index}
                showPricing={true}
                handleNotFeasible={handleNotFeasible}
            />
        );
    };

    if (mapInitIsLoading) {
        return <Loader />;
    }

    if (initError) {
        console.log('Error retrieving map init data', initError);
        return <p>Error retrieving map init data</p>;
    }
    return (
        <Kanban
            title="Property Pipeline"
            kanbanStatuses={{
                statusNames: PropertyPipelineStatuses,
                dictionary: propertyStatusesDict,
            }}
            kanbanItemRenderer={renderPropertyCard}
        />
    );
}

export default PropertyPipelineKanban;
